// Hides server names, team names and IP addresses in ServiceNow text before the notes show it.
//
// This is display-only. The API still returns the raw text (the detail table shows it as written), so this is
// not a security control: anyone allowed to open the page can read the raw cause in the table or the API.

// Server and team names: four or more words joined by hyphens, and also holding a digit, written in capitals,
// or naming a server role (uksouth-highq-prod-vm-dns1, INFRA-SRE-HIGHQ-TR). Ordinary hyphenated words and dates
// are left alone ("system-generated", "end-to-end-test", "04-September-2026"). An article in front of a name is
// swallowed so the replacement does not read "an an internal system".
const HYPHENATED = /(\b(?:an?|the)\s+)?(\b[a-z0-9]+(?:-[a-z0-9]+){3,}\b)/gi;

// Product names carry digits too ("windows-server-2019-datacenter") but are not internal.
const PRODUCT_PREFIX = /^(?:windows|microsoft|ms|office|linux|ubuntu|debian|centos|rhel|redhat|oracle|java|apache|nginx|azure|aws|google)-/i;

const looksInternal = (word) => !PRODUCT_PREFIX.test(word) && (
  /\d/.test(word)
  || word === word.toUpperCase()
  || /(?:^|-)(?:prod|vm|dns|srv|sql|db|sre|infra)(?:-|$)/i.test(word)
);

// Four numbers joined by dots, unless it is labelled as a version ("version 10.0.3.2", "v10.0.3.2", "build 1.2.3.4").
// A full stop after the last number is the end of a sentence, so it still counts; a further ".digit" does not.
const IP_ADDRESS = /(?<!\b(?:version|ver|build|release|v)\s?)(?<![\w.])(?:\d{1,3}\.){3}\d{1,3}(?!\w|\.\d)/gi;

/** ServiceNow text with server names and addresses replaced, for text people read outside the engineering team. */
export const forReaders = (text) => String(text || '')
  .replace(IP_ADDRESS, 'an internal address')
  .replace(HYPHENATED, (whole, article, word) => (looksInternal(word) ? 'an internal system' : whole));
